var items = {
  "block.minecraft.air": "공기",
  "block.minecraft.stone": "돌",
  "block.minecraft.granite": "화강암",
  "block.minecraft.polished_granite": "윤나는 화강암",
  "block.minecraft.diorite": "섬록암",
  "block.minecraft.polished_diorite": "윤나는 섬록암",
  "block.minecraft.andesite": "안산암",
  "block.minecraft.polished_andesite": "윤나는 안산암",
  "block.minecraft.grass_block": "잔디 블록",
  "block.minecraft.dirt": "흙",
  "block.minecraft.coarse_dirt": "거친 흙",
  "block.minecraft.podzol": "회백토",
  "block.minecraft.crimson_nylium": "진홍빛 네사체",
  "block.minecraft.warped_nylium": "뒤틀린 네사체",
  "block.minecraft.cobblestone": "조약돌",
  "block.minecraft.oak_planks": "참나무 판자",
  "block.minecraft.spruce_planks": "가문비나무 판자",
  "block.minecraft.birch_planks": "자작나무 판자",
  "block.minecraft.jungle_planks": "정글나무 판자",
  "block.minecraft.acacia_planks": "아카시아나무 판자",
  "block.minecraft.dark_oak_planks": "짙은 참나무 판자",
  "block.minecraft.crimson_planks": "진홍빛 판자",
  "block.minecraft.warped_planks": "뒤틀린 판자",
  "block.minecraft.oak_sapling": "참나무 묘목",
  "block.minecraft.spruce_sapling": "가문비나무 묘목",
  "block.minecraft.birch_sapling": "자작나무 묘목",
  "block.minecraft.jungle_sapling": "정글나무 묘목",
  "block.minecraft.acacia_sapling": "아카시아나무 묘목",
  "block.minecraft.dark_oak_sapling": "짙은 참나무 묘목",
  "block.minecraft.bedrock": "기반암",
  "block.minecraft.sand": "모래",
  "block.minecraft.red_sand": "붉은 모래",
  "block.minecraft.gravel": "자갈",
  "block.minecraft.gold_ore": "금 광석",
  "block.minecraft.iron_ore": "철 광석",
  "block.minecraft.coal_ore": "석탄 광석",
  "block.minecraft.nether_gold_ore": "네더 금 광석",
  "block.minecraft.oak_log": "참나무 원목",
  "block.minecraft.spruce_log": "가문비나무 원목",
  "block.minecraft.birch_log": "자작나무 원목",
  "block.minecraft.jungle_log": "정글나무 원목",
  "block.minecraft.acacia_log": "아카시아나무 원목",
  "block.minecraft.dark_oak_log": "짙은 참나무 원목",
  "block.minecraft.crimson_stem": "진홍빛 자루",
  "block.minecraft.warped_stem": "뒤틀린 자루",
  "block.minecraft.stripped_oak_log": "껍질 벗긴 참나무 원목",
  "block.minecraft.stripped_spruce_log": "껍질 벗긴 가문비나무 원목",
  "block.minecraft.stripped_birch_log": "껍질 벗긴 자작나무 원목",
  "block.minecraft.stripped_jungle_log": "껍질 벗긴 정글나무 원목",
  "block.minecraft.stripped_acacia_log": "껍질 벗긴 아카시아나무 원목",
  "block.minecraft.stripped_dark_oak_log": "껍질 벗긴 짙은 참나무 원목",
  "block.minecraft.stripped_crimson_stem": "껍질 벗긴 진홍빛 자루",
  "block.minecraft.stripped_warped_stem": "껍질 벗긴 뒤틀린 자루",
  "block.minecraft.stripped_oak_wood": "껍질 벗긴 참나무",
  "block.minecraft.stripped_spruce_wood": "껍질 벗긴 가문비나무",
  "block.minecraft.stripped_birch_wood": "껍질 벗긴 자작나무",
  "block.minecraft.stripped_jungle_wood": "껍질 벗긴 정글나무",
  "block.minecraft.stripped_acacia_wood": "껍질 벗긴 아카시아나무",
  "block.minecraft.stripped_dark_oak_wood": "껍질 벗긴 짙은 참나무",
  "block.minecraft.stripped_crimson_hyphae": "껍질 벗긴 진홍빛 균사",
  "block.minecraft.stripped_warped_hyphae": "껍질 벗긴 뒤틀린 균사",
  "block.minecraft.oak_wood": "참나무",
  "block.minecraft.spruce_wood": "가문비나무",
  "block.minecraft.birch_wood": "자작나무",
  "block.minecraft.jungle_wood": "정글나무",
  "block.minecraft.acacia_wood": "아카시아나무",
  "block.minecraft.dark_oak_wood": "짙은 참나무",
  "block.minecraft.crimson_hyphae": "진홍빛 균사",
  "block.minecraft.warped_hyphae": "뒤틀린 균사",
  "block.minecraft.oak_leaves": "참나무 잎",
  "block.minecraft.spruce_leaves": "가문비나무 잎",
  "block.minecraft.birch_leaves": "자작나무 잎",
  "block.minecraft.jungle_leaves": "정글나무 잎",
  "block.minecraft.acacia_leaves": "아카시아나무 잎",
  "block.minecraft.dark_oak_leaves": "짙은 참나무 잎",
  "block.minecraft.sponge": "스펀지",
  "block.minecraft.wet_sponge": "젖은 스펀지",
  "block.minecraft.glass": "유리",
  "block.minecraft.lapis_ore": "청금석 광석",
  "block.minecraft.lapis_block": "청금석 블록",
  "block.minecraft.dispenser": "발사기",
  "block.minecraft.sandstone": "사암",
  "block.minecraft.chiseled_sandstone": "조각된 사암",
  "block.minecraft.cut_sandstone": "깎인 사암",
  "block.minecraft.note_block": "소리 블록",
  "block.minecraft.powered_rail": "전동 레일",
  "block.minecraft.detector_rail": "감지 레일",
  "block.minecraft.sticky_piston": "끈끈이 피스톤",
  "block.minecraft.cobweb": "거미줄",
  "block.minecraft.grass": "잔디",
  "block.minecraft.fern": "고사리",
  "block.minecraft.dead_bush": "마른 덤불",
  "block.minecraft.seagrass": "해초",
  "block.minecraft.sea_pickle": "불우렁쉥이",
  "block.minecraft.piston": "피스톤",
  "block.minecraft.white_wool": "하얀색 양털",
  "block.minecraft.orange_wool": "주황색 양털",
  "block.minecraft.magenta_wool": "자홍색 양털",
  "block.minecraft.light_blue_wool": "하늘색 양털",
  "block.minecraft.yellow_wool": "노란색 양털",
  "block.minecraft.lime_wool": "연두색 양털",
  "block.minecraft.pink_wool": "분홍색 양털",
  "block.minecraft.gray_wool": "회색 양털",
  "block.minecraft.light_gray_wool": "회백색 양털",
  "block.minecraft.cyan_wool": "청록색 양털",
  "block.minecraft.purple_wool": "보라색 양털",
  "block.minecraft.blue_wool": "파란색 양털",
  "block.minecraft.brown_wool": "갈색 양털",
  "block.minecraft.green_wool": "초록색 양털",
  "block.minecraft.red_wool": "빨간색 양털",
  "block.minecraft.black_wool": "검은색 양털",
  "block.minecraft.dandelion": "민들레",
  "block.minecraft.poppy": "양귀비",
  "block.minecraft.blue_orchid": "파란색 난초",
  "block.minecraft.allium": "파꽃",
  "block.minecraft.azure_bluet": "선애기별꽃",
  "block.minecraft.red_tulip": "빨간색 튤립",
  "block.minecraft.orange_tulip": "주황색 튤립",
  "block.minecraft.white_tulip": "하얀색 튤립",
  "block.minecraft.pink_tulip": "분홍색 튤립",
  "block.minecraft.oxeye_daisy": "데이지",
  "block.minecraft.cornflower": "수레국화",
  "block.minecraft.lily_of_the_valley": "은방울꽃",
  "block.minecraft.wither_rose": "위더 장미",
  "block.minecraft.brown_mushroom": "갈색 버섯",
  "block.minecraft.red_mushroom": "빨간색 버섯",
  "block.minecraft.crimson_fungus": "진홍빛 균",
  "block.minecraft.warped_fungus": "뒤틀린 균",
  "block.minecraft.crimson_roots": "진홍빛 뿌리",
  "block.minecraft.warped_roots": "뒤틀린 뿌리",
  "block.minecraft.nether_sprouts": "네더 싹",
  "block.minecraft.weeping_vines": "늘어진 덩굴",
  "block.minecraft.twisting_vines": "휘어진 덩굴",
  "block.minecraft.sugar_cane": "사탕수수",
  "block.minecraft.kelp": "켈프",
  "block.minecraft.bamboo": "대나무",
  "block.minecraft.gold_block": "금 블록",
  "block.minecraft.iron_block": "철 블록",
  "block.minecraft.oak_slab": "참나무 반 블록",
  "block.minecraft.spruce_slab": "가문비나무 반 블록",
  "block.minecraft.birch_slab": "자작나무 반 블록",
  "block.minecraft.jungle_slab": "정글나무 반 블록",
  "block.minecraft.acacia_slab": "아카시아나무 반 블록",
  "block.minecraft.dark_oak_slab": "짙은 참나무 반 블록",
  "block.minecraft.crimson_slab": "진홍빛 반 블록",
  "block.minecraft.warped_slab": "뒤틀린 반 블록",
  "block.minecraft.stone_slab": "돌 반 블록",
  "block.minecraft.smooth_stone_slab": "매끄러운 돌 반 블록",
  "block.minecraft.sandstone_slab": "사암 반 블록",
  "block.minecraft.cut_sandstone_slab": "깎인 사암 반 블록",
  "block.minecraft.petrified_oak_slab": "규화한 참나무 반 블록",
  "block.minecraft.cobblestone_slab": "조약돌 반 블록",
  "block.minecraft.brick_slab": "벽돌 반 블록",
  "block.minecraft.stone_brick_slab": "석재 벽돌 반 블록",
  "block.minecraft.nether_brick_slab": "네더 벽돌 반 블록",
  "block.minecraft.quartz_slab": "석영 반 블록",
  "block.minecraft.red_sandstone_slab": "붉은 사암 반 블록",
  "block.minecraft.cut_red_sandstone_slab": "깎인 붉은 사암 반 블록",
  "block.minecraft.purpur_slab": "퍼퍼 반 블록",
  "block.minecraft.prismarine_slab": "프리즈머린 반 블록",
  "block.minecraft.prismarine_brick_slab": "프리즈머린 벽돌 반 블록",
  "block.minecraft.dark_prismarine_slab": "짙은 프리즈머린 반 블록",
  "block.minecraft.smooth_quartz": "매끄러운 석영 블록",
  "block.minecraft.smooth_red_sandstone": "매끄러운 붉은 사암",
  "block.minecraft.smooth_sandstone": "매끄러운 사암",
  "block.minecraft.smooth_stone": "매끄러운 돌",
  "block.minecraft.bricks": "벽돌",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "책장",
  "block.minecraft.mossy_cobblestone": "이끼 낀 조약돌",
  "block.minecraft.obsidian": "흑요석",
  "block.minecraft.torch": "횃불",
  "block.minecraft.end_rod": "엔드 막대기",
  "block.minecraft.chorus_plant": "후렴초",
  "block.minecraft.chorus_flower": "후렴화",
  "block.minecraft.purpur_block": "퍼퍼 블록",
  "block.minecraft.purpur_pillar": "퍼퍼 기둥",
  "block.minecraft.purpur_stairs": "퍼퍼 계단",
  "block.minecraft.spawner": "생성기",
  "block.minecraft.oak_stairs": "참나무 계단",
  "block.minecraft.chest": "상자",
  "block.minecraft.diamond_ore": "다이아몬드 광석",
  "block.minecraft.diamond_block": "다이아몬드 블록",
  "block.minecraft.crafting_table": "제작대",
  "block.minecraft.farmland": "경작지",
  "block.minecraft.furnace": "화로",
  "block.minecraft.ladder": "사다리",
  "block.minecraft.rail": "레일",
  "block.minecraft.cobblestone_stairs": "조약돌 계단",
  "block.minecraft.lever": "레버",
  "block.minecraft.stone_pressure_plate": "돌 압력판",
  "block.minecraft.oak_pressure_plate": "참나무 압력판",
  "block.minecraft.spruce_pressure_plate": "가문비나무 압력판",
  "block.minecraft.birch_pressure_plate": "자작나무 압력판",
  "block.minecraft.jungle_pressure_plate": "정글나무 압력판",
  "block.minecraft.acacia_pressure_plate": "아카시아나무 압력판",
  "block.minecraft.dark_oak_pressure_plate": "짙은 참나무 압력판",
  "block.minecraft.crimson_pressure_plate": "진홍빛 압력판",
  "block.minecraft.warped_pressure_plate": "뒤틀린 압력판",
  "block.minecraft.polished_blackstone_pressure_plate": "윤나는 흑암 압력판",
  "block.minecraft.redstone_ore": "레드스톤 광석",
  "block.minecraft.redstone_torch": "레드스톤 횃불",
  "block.minecraft.snow": "눈",
  "block.minecraft.ice": "얼음",
  "block.minecraft.snow_block": "눈 블록",
  "block.minecraft.cactus": "선인장",
  "block.minecraft.clay": "점토",
  "block.minecraft.jukebox": "주크박스",
  "block.minecraft.oak_fence": "참나무 울타리",
  "block.minecraft.spruce_fence": "가문비나무 울타리",
  "block.minecraft.birch_fence": "자작나무 울타리",
  "block.minecraft.jungle_fence": "정글나무 울타리",
  "block.minecraft.acacia_fence": "아카시아나무 울타리",
  "block.minecraft.dark_oak_fence": "짙은 참나무 울타리",
  "block.minecraft.crimson_fence": "진홍빛 울타리",
  "block.minecraft.warped_fence": "뒤틀린 울타리",
  "block.minecraft.pumpkin": "호박",
  "block.minecraft.carved_pumpkin": "조각된 호박",
  "block.minecraft.netherrack": "네더랙",
  "block.minecraft.soul_sand": "영혼 모래",
  "block.minecraft.soul_soil": "영혼 흙",
  "block.minecraft.basalt": "현무암",
  "block.minecraft.polished_basalt": "윤나는 현무암",
  "block.minecraft.soul_torch": "영혼 횃불",
  "block.minecraft.glowstone": "발광석",
  "block.minecraft.jack_o_lantern": "잭오랜턴",
  "block.minecraft.oak_trapdoor": "참나무 다락문",
  "block.minecraft.spruce_trapdoor": "가문비나무 다락문",
  "block.minecraft.birch_trapdoor": "자작나무 다락문",
  "block.minecraft.jungle_trapdoor": "정글나무 다락문",
  "block.minecraft.acacia_trapdoor": "아카시아나무 다락문",
  "block.minecraft.dark_oak_trapdoor": "짙은 참나무 다락문",
  "block.minecraft.crimson_trapdoor": "진홍빛 다락문",
  "block.minecraft.warped_trapdoor": "뒤틀린 다락문",
  "block.minecraft.infested_stone": "벌레 먹은 돌",
  "block.minecraft.infested_cobblestone": "벌레 먹은 조약돌",
  "block.minecraft.infested_stone_bricks": "벌레 먹은 석재 벽돌",
  "block.minecraft.infested_mossy_stone_bricks": "벌레 먹은 이끼 낀 석재 벽돌",
  "block.minecraft.infested_cracked_stone_bricks": "벌레 먹은 금 간 석재 벽돌",
  "block.minecraft.infested_chiseled_stone_bricks": "벌레 먹은 조각된 석재 벽돌",
  "block.minecraft.stone_bricks": "석재 벽돌",
  "block.minecraft.mossy_stone_bricks": "이끼 낀 석재 벽돌",
  "block.minecraft.cracked_stone_bricks": "금 간 석재 벽돌",
  "block.minecraft.chiseled_stone_bricks": "조각된 석재 벽돌",
  "block.minecraft.brown_mushroom_block": "갈색 버섯 블록",
  "block.minecraft.red_mushroom_block": "빨간색 버섯 블록",
  "block.minecraft.mushroom_stem": "버섯 자루",
  "block.minecraft.iron_bars": "철창",
  "block.minecraft.chain": "사슬",
  "block.minecraft.glass_pane": "유리판",
  "block.minecraft.melon": "수박",
  "block.minecraft.vine": "덩굴",
  "block.minecraft.oak_fence_gate": "참나무 울타리 문",
  "block.minecraft.spruce_fence_gate": "가문비나무 울타리 문",
  "block.minecraft.birch_fence_gate": "자작나무 울타리 문",
  "block.minecraft.jungle_fence_gate": "정글나무 울타리 문",
  "block.minecraft.acacia_fence_gate": "아카시아나무 울타리 문",
  "block.minecraft.dark_oak_fence_gate": "짙은 참나무 울타리 문",
  "block.minecraft.crimson_fence_gate": "진홍빛 울타리 문",
  "block.minecraft.warped_fence_gate": "뒤틀린 울타리 문",
  "block.minecraft.brick_stairs": "벽돌 계단",
  "block.minecraft.stone_brick_stairs": "석재 벽돌 계단",
  "block.minecraft.mycelium": "균사체",
  "block.minecraft.lily_pad": "수련잎",
  "block.minecraft.nether_bricks": "네더 벽돌",
  "block.minecraft.cracked_nether_bricks": "금 간 네더 벽돌",
  "block.minecraft.chiseled_nether_bricks": "조각된 네더 벽돌",
  "block.minecraft.nether_brick_fence": "네더 벽돌 울타리",
  "block.minecraft.nether_brick_stairs": "네더 벽돌 계단",
  "block.minecraft.enchanting_table": "마법 부여대",
  "block.minecraft.end_portal_frame": "엔드 차원문 틀",
  "block.minecraft.end_stone": "엔드 돌",
  "block.minecraft.end_stone_bricks": "엔드 석재 벽돌",
  "block.minecraft.dragon_egg": "드래곤 알",
  "block.minecraft.redstone_lamp": "레드스톤 조명",
  "block.minecraft.sandstone_stairs": "사암 계단",
  "block.minecraft.emerald_ore": "에메랄드 광석",
  "block.minecraft.ender_chest": "엔더 상자",
  "block.minecraft.tripwire_hook": "철사 덫 갈고리",
  "block.minecraft.emerald_block": "에메랄드 블록",
  "block.minecraft.spruce_stairs": "가문비나무 계단",
  "block.minecraft.birch_stairs": "자작나무 계단",
  "block.minecraft.jungle_stairs": "정글나무 계단",
  "block.minecraft.crimson_stairs": "진홍빛 계단",
  "block.minecraft.warped_stairs": "뒤틀린 계단",
  "block.minecraft.command_block": "명령 블록",
  "block.minecraft.beacon": "신호기",
  "block.minecraft.cobblestone_wall": "조약돌 담장",
  "block.minecraft.mossy_cobblestone_wall": "이끼 낀 조약돌 담장",
  "block.minecraft.brick_wall": "벽돌 담장",
  "block.minecraft.prismarine_wall": "프리즈머린 담장",
  "block.minecraft.red_sandstone_wall": "붉은 사암 담장",
  "block.minecraft.mossy_stone_brick_wall": "이끼 낀 석재 벽돌 담장",
  "block.minecraft.granite_wall": "화강암 담장",
  "block.minecraft.stone_brick_wall": "석재 벽돌 담장",
  "block.minecraft.nether_brick_wall": "네더 벽돌 담장",
  "block.minecraft.andesite_wall": "안산암 담장",
  "block.minecraft.red_nether_brick_wall": "붉은 네더 벽돌 담장",
  "block.minecraft.sandstone_wall": "사암 담장",
  "block.minecraft.end_stone_brick_wall": "엔드 석재 벽돌 담장",
  "block.minecraft.diorite_wall": "섬록암 담장",
  "block.minecraft.blackstone_wall": "흑암 담장",
  "block.minecraft.polished_blackstone_wall": "윤나는 흑암 담장",
  "block.minecraft.polished_blackstone_brick_wall": "윤나는 흑암 벽돌 담장",
  "block.minecraft.stone_button": "돌 버튼",
  "block.minecraft.oak_button": "참나무 버튼",
  "block.minecraft.spruce_button": "가문비나무 버튼",
  "block.minecraft.birch_button": "자작나무 버튼",
  "block.minecraft.jungle_button": "정글나무 버튼",
  "block.minecraft.acacia_button": "아카시아나무 버튼",
  "block.minecraft.dark_oak_button": "짙은 참나무 버튼",
  "block.minecraft.crimson_button": "진홍빛 버튼",
  "block.minecraft.warped_button": "뒤틀린 버튼",
  "block.minecraft.polished_blackstone_button": "윤나는 흑암 버튼",
  "block.minecraft.anvil": "모루",
  "block.minecraft.chipped_anvil": "금 간 모루",
  "block.minecraft.damaged_anvil": "손상된 모루",
  "block.minecraft.trapped_chest": "덫 상자",
  "block.minecraft.light_weighted_pressure_plate": "경형 무게 압력판",
  "block.minecraft.heavy_weighted_pressure_plate": "중형 무게 압력판",
  "block.minecraft.daylight_detector": "햇빛 감지기",
  "block.minecraft.redstone_block": "레드스톤 블록",
  "block.minecraft.nether_quartz_ore": "네더 석영 광석",
  "block.minecraft.hopper": "호퍼",
  "block.minecraft.chiseled_quartz_block": "조각된 석영 블록",
  "block.minecraft.quartz_block": "석영 블록",
  "block.minecraft.quartz_bricks": "석영 벽돌",
  "block.minecraft.quartz_pillar": "석영 기둥",
  "block.minecraft.quartz_stairs": "석영 계단",
  "block.minecraft.activator_rail": "활성화 레일",
  "block.minecraft.dropper": "공급기",
  "block.minecraft.white_terracotta": "하얀색 테라코타",
  "block.minecraft.orange_terracotta": "주황색 테라코타",
  "block.minecraft.magenta_terracotta": "자홍색 테라코타",
  "block.minecraft.light_blue_terracotta": "하늘색 테라코타",
  "block.minecraft.yellow_terracotta": "노란색 테라코타",
  "block.minecraft.lime_terracotta": "연두색 테라코타",
  "block.minecraft.pink_terracotta": "분홍색 테라코타",
  "block.minecraft.gray_terracotta": "회색 테라코타",
  "block.minecraft.light_gray_terracotta": "회백색 테라코타",
  "block.minecraft.cyan_terracotta": "청록색 테라코타",
  "block.minecraft.purple_terracotta": "보라색 테라코타",
  "block.minecraft.blue_terracotta": "파란색 테라코타",
  "block.minecraft.brown_terracotta": "갈색 테라코타",
  "block.minecraft.green_terracotta": "초록색 테라코타",
  "block.minecraft.red_terracotta": "빨간색 테라코타",
  "block.minecraft.black_terracotta": "검은색 테라코타",
  "block.minecraft.barrier": "방벽",
  "block.minecraft.iron_trapdoor": "철 다락문",
  "block.minecraft.hay_block": "건초 더미",
  "block.minecraft.white_carpet": "하얀색 양탄자",
  "block.minecraft.orange_carpet": "주황색 양탄자",
  "block.minecraft.magenta_carpet": "자홍색 양탄자",
  "block.minecraft.light_blue_carpet": "하늘색 양탄자",
  "block.minecraft.yellow_carpet": "노란색 양탄자",
  "block.minecraft.lime_carpet": "연두색 양탄자",
  "block.minecraft.pink_carpet": "분홍색 양탄자",
  "block.minecraft.gray_carpet": "회색 양탄자",
  "block.minecraft.light_gray_carpet": "회백색 양탄자",
  "block.minecraft.cyan_carpet": "청록색 양탄자",
  "block.minecraft.purple_carpet": "보라색 양탄자",
  "block.minecraft.blue_carpet": "파란색 양탄자",
  "block.minecraft.brown_carpet": "갈색 양탄자",
  "block.minecraft.green_carpet": "초록색 양탄자",
  "block.minecraft.red_carpet": "빨간색 양탄자",
  "block.minecraft.black_carpet": "검은색 양탄자",
  "block.minecraft.terracotta": "테라코타",
  "block.minecraft.coal_block": "석탄 블록",
  "block.minecraft.packed_ice": "꽁꽁 언 얼음",
  "block.minecraft.acacia_stairs": "아카시아나무 계단",
  "block.minecraft.dark_oak_stairs": "짙은 참나무 계단",
  "block.minecraft.slime_block": "슬라임 블록",
  "block.minecraft.grass_path": "잔디 길",
  "block.minecraft.sunflower": "해바라기",
  "block.minecraft.lilac": "라일락",
  "block.minecraft.rose_bush": "장미 덤불",
  "block.minecraft.peony": "모란",
  "block.minecraft.tall_grass": "키 큰 잔디",
  "block.minecraft.large_fern": "큰 고사리",
  "block.minecraft.white_stained_glass": "하얀색 색유리",
  "block.minecraft.orange_stained_glass": "주황색 색유리",
  "block.minecraft.magenta_stained_glass": "자홍색 색유리",
  "block.minecraft.light_blue_stained_glass": "하늘색 색유리",
  "block.minecraft.yellow_stained_glass": "노란색 색유리",
  "block.minecraft.lime_stained_glass": "연두색 색유리",
  "block.minecraft.pink_stained_glass": "분홍색 색유리",
  "block.minecraft.gray_stained_glass": "회색 색유리",
  "block.minecraft.light_gray_stained_glass": "회백색 색유리",
  "block.minecraft.cyan_stained_glass": "청록색 색유리",
  "block.minecraft.purple_stained_glass": "보라색 색유리",
  "block.minecraft.blue_stained_glass": "파란색 색유리",
  "block.minecraft.brown_stained_glass": "갈색 색유리",
  "block.minecraft.green_stained_glass": "초록색 색유리",
  "block.minecraft.red_stained_glass": "빨간색 색유리",
  "block.minecraft.black_stained_glass": "검은색 색유리",
  "block.minecraft.white_stained_glass_pane": "하얀색 색유리 판",
  "block.minecraft.orange_stained_glass_pane": "주황색 색유리 판",
  "block.minecraft.magenta_stained_glass_pane": "자홍색 색유리 판",
  "block.minecraft.light_blue_stained_glass_pane": "하늘색 색유리 판",
  "block.minecraft.yellow_stained_glass_pane": "노란색 색유리 판",
  "block.minecraft.lime_stained_glass_pane": "연두색 색유리 판",
  "block.minecraft.pink_stained_glass_pane": "분홍색 색유리 판",
  "block.minecraft.gray_stained_glass_pane": "회색 색유리 판",
  "block.minecraft.light_gray_stained_glass_pane": "회백색 색유리 판",
  "block.minecraft.cyan_stained_glass_pane": "청록색 색유리 판",
  "block.minecraft.purple_stained_glass_pane": "보라색 색유리 판",
  "block.minecraft.blue_stained_glass_pane": "파란색 색유리 판",
  "block.minecraft.brown_stained_glass_pane": "갈색 색유리 판",
  "block.minecraft.green_stained_glass_pane": "초록색 색유리 판",
  "block.minecraft.red_stained_glass_pane": "빨간색 색유리 판",
  "block.minecraft.black_stained_glass_pane": "검은색 색유리 판",
  "block.minecraft.prismarine": "프리즈머린",
  "block.minecraft.prismarine_bricks": "프리즈머린 벽돌",
  "block.minecraft.dark_prismarine": "짙은 프리즈머린",
  "block.minecraft.prismarine_stairs": "프리즈머린 계단",
  "block.minecraft.prismarine_brick_stairs": "프리즈머린 벽돌 계단",
  "block.minecraft.dark_prismarine_stairs": "짙은 프리즈머린 계단",
  "block.minecraft.sea_lantern": "바다 랜턴",
  "block.minecraft.red_sandstone": "붉은 사암",
  "block.minecraft.chiseled_red_sandstone": "조각된 붉은 사암",
  "block.minecraft.cut_red_sandstone": "깎인 붉은 사암",
  "block.minecraft.red_sandstone_stairs": "붉은 사암 계단",
  "block.minecraft.repeating_command_block": "반복형 명령 블록",
  "block.minecraft.chain_command_block": "연쇄형 명령 블록",
  "block.minecraft.magma_block": "마그마 블록",
  "block.minecraft.nether_wart_block": "네더 사마귀 블록",
  "block.minecraft.warped_wart_block": "뒤틀린 사마귀 블록",
  "block.minecraft.red_nether_bricks": "붉은 네더 벽돌",
  "block.minecraft.bone_block": "뼈 블록",
  "block.minecraft.structure_void": "구조물 공허 공간",
  "block.minecraft.observer": "관측기",
  "block.minecraft.shulker_box": "셜커 상자",
  "block.minecraft.white_shulker_box": "하얀색 셜커 상자",
  "block.minecraft.orange_shulker_box": "주황색 셜커 상자",
  "block.minecraft.magenta_shulker_box": "자홍색 셜커 상자",
  "block.minecraft.light_blue_shulker_box": "하늘색 셜커 상자",
  "block.minecraft.yellow_shulker_box": "노란색 셜커 상자",
  "block.minecraft.lime_shulker_box": "연두색 셜커 상자",
  "block.minecraft.pink_shulker_box": "분홍색 셜커 상자",
  "block.minecraft.gray_shulker_box": "회색 셜커 상자",
  "block.minecraft.light_gray_shulker_box": "회백색 셜커 상자",
  "block.minecraft.cyan_shulker_box": "청록색 셜커 상자",
  "block.minecraft.purple_shulker_box": "보라색 셜커 상자",
  "block.minecraft.blue_shulker_box": "파란색 셜커 상자",
  "block.minecraft.brown_shulker_box": "갈색 셜커 상자",
  "block.minecraft.green_shulker_box": "초록색 셜커 상자",
  "block.minecraft.red_shulker_box": "빨간색 셜커 상자",
  "block.minecraft.black_shulker_box": "검은색 셜커 상자",
  "block.minecraft.white_glazed_terracotta": "하얀색 유광 테라코타",
  "block.minecraft.orange_glazed_terracotta": "주황색 유광 테라코타",
  "block.minecraft.magenta_glazed_terracotta": "자홍색 유광 테라코타",
  "block.minecraft.light_blue_glazed_terracotta": "하늘색 유광 테라코타",
  "block.minecraft.yellow_glazed_terracotta": "노란색 유광 테라코타",
  "block.minecraft.lime_glazed_terracotta": "연두색 유광 테라코타",
  "block.minecraft.pink_glazed_terracotta": "분홍색 유광 테라코타",
  "block.minecraft.gray_glazed_terracotta": "회색 유광 테라코타",
  "block.minecraft.light_gray_glazed_terracotta": "회백색 유광 테라코타",
  "block.minecraft.cyan_glazed_terracotta": "청록색 유광 테라코타",
  "block.minecraft.purple_glazed_terracotta": "보라색 유광 테라코타",
  "block.minecraft.blue_glazed_terracotta": "파란색 유광 테라코타",
  "block.minecraft.brown_glazed_terracotta": "갈색 유광 테라코타",
  "block.minecraft.green_glazed_terracotta": "초록색 유광 테라코타",
  "block.minecraft.red_glazed_terracotta": "빨간색 유광 테라코타",
  "block.minecraft.black_glazed_terracotta": "검은색 유광 테라코타",
  "block.minecraft.white_concrete": "하얀색 콘크리트",
  "block.minecraft.orange_concrete": "주황색 콘크리트",
  "block.minecraft.magenta_concrete": "자홍색 콘크리트",
  "block.minecraft.light_blue_concrete": "하늘색 콘크리트",
  "block.minecraft.yellow_concrete": "노란색 콘크리트",
  "block.minecraft.lime_concrete": "연두색 콘크리트",
  "block.minecraft.pink_concrete": "분홍색 콘크리트",
  "block.minecraft.gray_concrete": "회색 콘크리트",
  "block.minecraft.light_gray_concrete": "회백색 콘크리트",
  "block.minecraft.cyan_concrete": "청록색 콘크리트",
  "block.minecraft.purple_concrete": "보라색 콘크리트",
  "block.minecraft.blue_concrete": "파란색 콘크리트",
  "block.minecraft.brown_concrete": "갈색 콘크리트",
  "block.minecraft.green_concrete": "초록색 콘크리트",
  "block.minecraft.red_concrete": "빨간색 콘크리트",
  "block.minecraft.black_concrete": "검은색 콘크리트",
  "block.minecraft.white_concrete_powder": "하얀색 콘크리트 가루",
  "block.minecraft.orange_concrete_powder": "주황색 콘크리트 가루",
  "block.minecraft.magenta_concrete_powder": "자홍색 콘크리트 가루",
  "block.minecraft.light_blue_concrete_powder": "하늘색 콘크리트 가루",
  "block.minecraft.yellow_concrete_powder": "노란색 콘크리트 가루",
  "block.minecraft.lime_concrete_powder": "연두색 콘크리트 가루",
  "block.minecraft.pink_concrete_powder": "분홍색 콘크리트 가루",
  "block.minecraft.gray_concrete_powder": "회색 콘크리트 가루",
  "block.minecraft.light_gray_concrete_powder": "회백색 콘크리트 가루",
  "block.minecraft.cyan_concrete_powder": "청록색 콘크리트 가루",
  "block.minecraft.purple_concrete_powder": "보라색 콘크리트 가루",
  "block.minecraft.blue_concrete_powder": "파란색 콘크리트 가루",
  "block.minecraft.brown_concrete_powder": "갈색 콘크리트 가루",
  "block.minecraft.green_concrete_powder": "초록색 콘크리트 가루",
  "block.minecraft.red_concrete_powder": "빨간색 콘크리트 가루",
  "block.minecraft.black_concrete_powder": "검은색 콘크리트 가루",
  "block.minecraft.turtle_egg": "거북 알",
  "block.minecraft.dead_tube_coral_block": "죽은 관 산호 블록",
  "block.minecraft.dead_brain_coral_block": "죽은 뇌 산호 블록",
  "block.minecraft.dead_bubble_coral_block": "죽은 거품 산호 블록",
  "block.minecraft.dead_fire_coral_block": "죽은 불 산호 블록",
  "block.minecraft.dead_horn_coral_block": "죽은 사방산호 블록",
  "block.minecraft.tube_coral_block": "관 산호 블록",
  "block.minecraft.brain_coral_block": "뇌 산호 블록",
  "block.minecraft.bubble_coral_block": "거품 산호 블록",
  "block.minecraft.fire_coral_block": "불 산호 블록",
  "block.minecraft.horn_coral_block": "사방산호 블록",
  "block.minecraft.tube_coral": "관 산호",
  "block.minecraft.brain_coral": "뇌 산호",
  "block.minecraft.bubble_coral": "거품 산호",
  "block.minecraft.fire_coral": "불 산호",
  "block.minecraft.horn_coral": "사방산호",
  "block.minecraft.dead_brain_coral": "죽은 뇌 산호",
  "block.minecraft.dead_bubble_coral": "죽은 거품 산호",
  "block.minecraft.dead_fire_coral": "죽은 불 산호",
  "block.minecraft.dead_horn_coral": "죽은 사방산호",
  "block.minecraft.dead_tube_coral": "죽은 관 산호",
  "block.minecraft.tube_coral_fan": "부채형 관 산호",
  "block.minecraft.brain_coral_fan": "부채형 뇌 산호",
  "block.minecraft.bubble_coral_fan": "부채형 거품 산호",
  "block.minecraft.fire_coral_fan": "부채형 불 산호",
  "block.minecraft.horn_coral_fan": "부채형 사방산호",
  "block.minecraft.dead_tube_coral_fan": "죽은 부채형 관 산호",
  "block.minecraft.dead_brain_coral_fan": "죽은 부채형 뇌 산호",
  "block.minecraft.dead_bubble_coral_fan": "죽은 부채형 거품 산호",
  "block.minecraft.dead_fire_coral_fan": "죽은 부채형 불 산호",
  "block.minecraft.dead_horn_coral_fan": "죽은 부채형 사방산호",
  "block.minecraft.blue_ice": "푸른얼음",
  "block.minecraft.conduit": "전달체",
  "block.minecraft.polished_granite_stairs": "윤나는 화강암 계단",
  "block.minecraft.smooth_red_sandstone_stairs": "매끄러운 붉은 사암 계단",
  "block.minecraft.mossy_stone_brick_stairs": "이끼 낀 석재 벽돌 계단",
  "block.minecraft.polished_diorite_stairs": "윤나는 섬록암 계단",
  "block.minecraft.mossy_cobblestone_stairs": "이끼 낀 조약돌 계단",
  "block.minecraft.end_stone_brick_stairs": "엔드 석재 벽돌 계단",
  "block.minecraft.stone_stairs": "돌 계단",
  "block.minecraft.smooth_sandstone_stairs": "매끄러운 사암 계단",
  "block.minecraft.smooth_quartz_stairs": "매끄러운 석영 계단",
  "block.minecraft.granite_stairs": "화강암 계단",
  "block.minecraft.andesite_stairs": "안산암 계단",
  "block.minecraft.red_nether_brick_stairs": "붉은 네더 벽돌 계단",
  "block.minecraft.polished_andesite_stairs": "윤나는 안산암 계단",
  "block.minecraft.diorite_stairs": "섬록암 계단",
  "block.minecraft.polished_granite_slab": "윤나는 화강암 반 블록",
  "block.minecraft.smooth_red_sandstone_slab": "매끄러운 붉은 사암 반 블록",
  "block.minecraft.mossy_stone_brick_slab": "이끼 낀 석재 벽돌 반 블록",
  "block.minecraft.polished_diorite_slab": "윤나는 섬록암 반 블록",
  "block.minecraft.mossy_cobblestone_slab": "이끼 낀 조약돌 반 블록",
  "block.minecraft.end_stone_brick_slab": "엔드 석재 벽돌 반 블록",
  "block.minecraft.smooth_sandstone_slab": "매끄러운 사암 반 블록",
  "block.minecraft.smooth_quartz_slab": "매끄러운 석영 반 블록",
  "block.minecraft.granite_slab": "화강암 반 블록",
  "block.minecraft.andesite_slab": "안산암 반 블록",
  "block.minecraft.red_nether_brick_slab": "붉은 네더 벽돌 반 블록",
  "block.minecraft.polished_andesite_slab": "윤나는 안산암 반 블록",
  "block.minecraft.diorite_slab": "섬록암 반 블록",
  "block.minecraft.scaffolding": "비계",
  "block.minecraft.iron_door": "철문",
  "block.minecraft.oak_door": "참나무 문",
  "block.minecraft.spruce_door": "가문비나무 문",
  "block.minecraft.birch_door": "자작나무 문",
  "block.minecraft.jungle_door": "정글나무 문",
  "block.minecraft.acacia_door": "아카시아나무 문",
  "block.minecraft.dark_oak_door": "짙은 참나무 문",
  "block.minecraft.crimson_door": "진홍빛 문",
  "block.minecraft.warped_door": "뒤틀린 문",
  "block.minecraft.repeater": "레드스톤 중계기",
  "block.minecraft.comparator": "레드스톤 비교기",
  "block.minecraft.structure_block": "구조물 블록",
  "block.minecraft.jigsaw": "직소 블록",
  "item.minecraft.turtle_helmet": "거북 등딱지□□머리에 있을 때:□+2 방어",
  "item.minecraft.scute": "인갑",
  "item.minecraft.iron_shovel": "철 삽□□주로 사용하는 손에 있을 때:□+3.5 공격 피해□-3 공격 속도",
  "item.minecraft.iron_pickaxe": "철 곡괭이□□주로 사용하는 손에 있을 때:□+3 공격 피해□-2.8 공격 속도",
  "item.minecraft.iron_axe": "철 도끼□□주로 사용하는 손에 있을 때:□+8 공격 피해□-3.1 공격 속도",
  "item.minecraft.flint_and_steel": "부싯돌과 부시",
  "item.minecraft.apple": "사과",
  "item.minecraft.bow": "활",
  "item.minecraft.arrow": "화살",
  "item.minecraft.coal": "석탄",
  "item.minecraft.charcoal": "숯",
  "item.minecraft.diamond": "다이아몬드",
  "item.minecraft.iron_ingot": "철 주괴",
  "item.minecraft.gold_ingot": "금 주괴",
  "item.minecraft.netherite_ingot": "네더라이트 주괴",
  "item.minecraft.netherite_scrap": "네더라이트 파편",
  "item.minecraft.iron_sword": "철 검□□주로 사용하는 손에 있을 때:□+5 공격 피해□-2.4 공격 속도",
  "item.minecraft.wooden_sword": "나무 검□□주로 사용하는 손에 있을 때:□+3 공격 피해□-2.4 공격 속도",
  "item.minecraft.wooden_shovel": "나무 삽□□주로 사용하는 손에 있을 때:□+1.5 공격 피해□-3 공격 속도",
  "item.minecraft.wooden_pickaxe": "나무 곡괭이□□주로 사용하는 손에 있을 때:□+1 공격 피해□-2.8 공격 속도",
  "item.minecraft.wooden_axe": "나무 도끼□□주로 사용하는 손에 있을 때:□+6 공격 피해□-3.2 공격 속도",
  "item.minecraft.stone_sword": "돌 검□□주로 사용하는 손에 있을 때:□+4 공격 피해□-2.4 공격 속도",
  "item.minecraft.stone_shovel": "돌 삽□□주로 사용하는 손에 있을 때:□+2.5 공격 피해□-3 공격 속도",
  "item.minecraft.stone_pickaxe": "돌 곡괭이□□주로 사용하는 손에 있을 때:□+2 공격 피해□-2.8 공격 속도",
  "item.minecraft.stone_axe": "돌 도끼□□주로 사용하는 손에 있을 때:□+8 공격 피해□-3.2 공격 속도",
  "item.minecraft.diamond_sword": "다이아몬드 검□□주로 사용하는 손에 있을 때:□+6 공격 피해□-2.4 공격 속도",
  "item.minecraft.diamond_shovel": "다이아몬드 삽□□주로 사용하는 손에 있을 때:□+4.5 공격 피해□-3 공격 속도",
  "item.minecraft.diamond_pickaxe": "다이아몬드 곡괭이□□주로 사용하는 손에 있을 때:□+4 공격 피해□-2.8 공격 속도",
  "item.minecraft.diamond_axe": "다이아몬드 도끼□□주로 사용하는 손에 있을 때:□+8 공격 피해□-3 공격 속도",
  "item.minecraft.stick": "막대기",
  "item.minecraft.bowl": "그릇",
  "item.minecraft.mushroom_stew": "버섯 스튜",
  "item.minecraft.golden_sword": "금 검□□주로 사용하는 손에 있을 때:□+3 공격 피해□-2.4 공격 속도",
  "item.minecraft.golden_shovel": "금 삽□□주로 사용하는 손에 있을 때:□+1.5 공격 피해□-3 공격 속도",
  "item.minecraft.golden_pickaxe": "금 곡괭이□□주로 사용하는 손에 있을 때:□+1 공격 피해□-2.8 공격 속도",
  "item.minecraft.golden_axe": "금 도끼□□주로 사용하는 손에 있을 때:□+6 공격 피해□-3 공격 속도",
  "item.minecraft.netherite_sword": "네더라이트 검□□주로 사용하는 손에 있을 때:□+7 공격 피해□-2.4 공격 속도",
  "item.minecraft.netherite_shovel": "네더라이트 삽□□주로 사용하는 손에 있을 때:□+5.5 공격 피해□-3 공격 속도",
  "item.minecraft.netherite_pickaxe": "네더라이트 곡괭이□□주로 사용하는 손에 있을 때:□+5 공격 피해□-2.8 공격 속도",
  "item.minecraft.netherite_axe": "네더라이트 도끼□□주로 사용하는 손에 있을 때:□+9 공격 피해□-3 공격 속도",
  "item.minecraft.string": "실",
  "item.minecraft.feather": "깃털",
  "item.minecraft.gunpowder": "화약",
  "item.minecraft.wooden_hoe": "나무 괭이□□주로 사용하는 손에 있을 때:□-3 공격 속도",
  "item.minecraft.stone_hoe": "돌 괭이□□주로 사용하는 손에 있을 때:□-2 공격 속도",
  "item.minecraft.iron_hoe": "철 괭이□□주로 사용하는 손에 있을 때:□-1 공격 속도",
  "item.minecraft.diamond_hoe": "다이아몬드 괭이□□주로 사용하는 손에 있을 때:",
  "item.minecraft.golden_hoe": "금 괭이□□주로 사용하는 손에 있을 때:□-3 공격 속도",
  "item.minecraft.netherite_hoe": "네더라이트 괭이□□주로 사용하는 손에 있을 때:",
  "item.minecraft.wheat_seeds": "밀 씨앗",
  "item.minecraft.wheat": "밀",
  "item.minecraft.bread": "빵",
  "item.minecraft.leather_helmet": "가죽 모자□□머리에 있을 때:□+1 방어",
  "item.minecraft.leather_chestplate": "가죽 조끼□□몸에 있을 때:□+3 방어",
  "item.minecraft.leather_leggings": "가죽 바지□□다리에 있을 때:□+2 방어",
  "item.minecraft.leather_boots": "가죽 장화□□발에 있을 때:□+1 방어",
  "item.minecraft.chainmail_helmet": "사슬 투구□□머리에 있을 때:□+2 방어",
  "item.minecraft.chainmail_chestplate": "사슬 흉갑□□몸에 있을 때:□+5 방어",
  "item.minecraft.chainmail_leggings": "사슬 레깅스□□다리에 있을 때:□+4 방어",
  "item.minecraft.chainmail_boots": "사슬 부츠□□발에 있을 때:□+1 방어",
  "item.minecraft.iron_helmet": "철 투구□□머리에 있을 때:□+2 방어",
  "item.minecraft.iron_chestplate": "철 흉갑□□몸에 있을 때:□+6 방어",
  "item.minecraft.iron_leggings": "철 레깅스□□다리에 있을 때:□+5 방어",
  "item.minecraft.iron_boots": "철 부츠□□발에 있을 때:□+2 방어",
  "item.minecraft.diamond_helmet": "다이아몬드 투구□□머리에 있을 때:□+3 방어□+2 방어 강도",
  "item.minecraft.diamond_chestplate": "다이아몬드 흉갑□□몸에 있을 때:□+8 방어□+2 방어 강도",
  "item.minecraft.diamond_leggings": "다이아몬드 레깅스□□다리에 있을 때:□+6 방어□+2 방어 강도",
  "item.minecraft.diamond_boots": "다이아몬드 부츠□□발에 있을 때:□+3 방어□+2 방어 강도",
  "item.minecraft.golden_helmet": "금 투구□□머리에 있을 때:□+2 방어",
  "item.minecraft.golden_chestplate": "금 흉갑□□몸에 있을 때:□+5 방어",
  "item.minecraft.golden_leggings": "금 레깅스□□다리에 있을 때:□+3 방어",
  "item.minecraft.golden_boots": "금 부츠□□발에 있을 때:□+1 방어",
  "item.minecraft.netherite_helmet": "네더라이트 투구□□머리에 있을 때:□+3 방어□+3 방어 강도□+1 밀치기 저항",
  "item.minecraft.netherite_chestplate": "네더라이트 흉갑□□몸에 있을 때:□+8 방어□+3 방어 강도□+1 밀치기 저항",
  "item.minecraft.netherite_leggings": "네더라이트 레깅스□□다리에 있을 때:□+6 방어□+3 방어 강도□+1 밀치기 저항",
  "item.minecraft.netherite_boots": "네더라이트 부츠□□발에 있을 때:□+3 방어□+3 방어 강도□+1 밀치기 저항",
  "item.minecraft.flint": "부싯돌",
  "item.minecraft.porkchop": "익히지 않은 돼지고기",
  "item.minecraft.cooked_porkchop": "익힌 돼지고기",
  "item.minecraft.painting": "그림",
  "item.minecraft.golden_apple": "황금 사과",
  "item.minecraft.enchanted_golden_apple": "마법이 부여된 황금 사과",
  "block.minecraft.oak_sign": "참나무 표지판",
  "block.minecraft.spruce_sign": "가문비나무 표지판",
  "block.minecraft.birch_sign": "자작나무 표지판",
  "block.minecraft.jungle_sign": "정글나무 표지판",
  "block.minecraft.acacia_sign": "아카시아나무 표지판",
  "block.minecraft.dark_oak_sign": "짙은 참나무 표지판",
  "block.minecraft.crimson_sign": "진홍빛 표지판",
  "block.minecraft.warped_sign": "뒤틀린 표지판",
  "item.minecraft.bucket": "양동이",
  "item.minecraft.water_bucket": "물 양동이",
  "item.minecraft.lava_bucket": "용암 양동이",
  "item.minecraft.minecart": "광산 수레",
  "item.minecraft.saddle": "안장",
  "item.minecraft.redstone": "레드스톤 가루",
  "item.minecraft.snowball": "눈덩이",
  "item.minecraft.oak_boat": "참나무 보트",
  "item.minecraft.leather": "가죽",
  "item.minecraft.milk_bucket": "우유 양동이",
  "item.minecraft.pufferfish_bucket": "복어가 담긴 양동이",
  "item.minecraft.salmon_bucket": "연어가 담긴 양동이",
  "item.minecraft.cod_bucket": "대구가 담긴 양동이",
  "item.minecraft.tropical_fish_bucket": "열대어가 담긴 양동이",
  "item.minecraft.brick": "벽돌",
  "item.minecraft.clay_ball": "점토 덩이",
  "block.minecraft.dried_kelp_block": "말린 켈프 블록",
  "item.minecraft.paper": "종이",
  "item.minecraft.book": "책",
  "item.minecraft.slime_ball": "슬라임볼",
  "item.minecraft.chest_minecart": "상자가 실린 광산 수레",
  "item.minecraft.furnace_minecart": "화로가 실린 광산 수레",
  "item.minecraft.egg": "달걀",
  "item.minecraft.compass": "나침반",
  "item.minecraft.fishing_rod": "낚싯대",
  "item.minecraft.clock": "시계",
  "item.minecraft.glowstone_dust": "발광석 가루",
  "item.minecraft.cod": "익히지 않은 대구",
  "item.minecraft.salmon": "익히지 않은 연어",
  "item.minecraft.tropical_fish": "열대어",
  "item.minecraft.pufferfish": "복어",
  "item.minecraft.cooked_cod": "익힌 대구",
  "item.minecraft.cooked_salmon": "익힌 연어",
  "item.minecraft.ink_sac": "먹물 주머니",
  "item.minecraft.red_dye": "빨간색 염료",
  "item.minecraft.green_dye": "초록색 염료",
  "item.minecraft.cocoa_beans": "코코아 콩",
  "item.minecraft.lapis_lazuli": "청금석",
  "item.minecraft.purple_dye": "보라색 염료",
  "item.minecraft.cyan_dye": "청록색 염료",
  "item.minecraft.light_gray_dye": "회백색 염료",
  "item.minecraft.gray_dye": "회색 염료",
  "item.minecraft.pink_dye": "분홍색 염료",
  "item.minecraft.lime_dye": "연두색 염료",
  "item.minecraft.yellow_dye": "노란색 염료",
  "item.minecraft.light_blue_dye": "하늘색 염료",
  "item.minecraft.magenta_dye": "자홍색 염료",
  "item.minecraft.orange_dye": "주황색 염료",
  "item.minecraft.bone_meal": "뼛가루",
  "item.minecraft.blue_dye": "파란색 염료",
  "item.minecraft.brown_dye": "갈색 염료",
  "item.minecraft.black_dye": "검은색 염료",
  "item.minecraft.white_dye": "하얀색 염료",
  "item.minecraft.bone": "뼈다귀",
  "item.minecraft.sugar": "설탕",
  "block.minecraft.cake": "케이크",
  "block.minecraft.white_bed": "하얀색 침대",
  "block.minecraft.orange_bed": "주황색 침대",
  "block.minecraft.magenta_bed": "자홍색 침대",
  "block.minecraft.light_blue_bed": "하늘색 침대",
  "block.minecraft.yellow_bed": "노란색 침대",
  "block.minecraft.lime_bed": "연두색 침대",
  "block.minecraft.pink_bed": "분홍색 침대",
  "block.minecraft.gray_bed": "회색 침대",
  "block.minecraft.light_gray_bed": "회백색 침대",
  "block.minecraft.cyan_bed": "청록색 침대",
  "block.minecraft.purple_bed": "보라색 침대",
  "block.minecraft.blue_bed": "파란색 침대",
  "block.minecraft.brown_bed": "갈색 침대",
  "block.minecraft.green_bed": "초록색 침대",
  "block.minecraft.red_bed": "빨간색 침대",
  "block.minecraft.black_bed": "검은색 침대",
  "item.minecraft.cookie": "쿠키",
  "item.minecraft.filled_map": "지도□#0",
  "item.minecraft.shears": "가위",
  "item.minecraft.melon_slice": "수박 조각",
  "item.minecraft.dried_kelp": "말린 켈프",
  "item.minecraft.pumpkin_seeds": "호박씨",
  "item.minecraft.melon_seeds": "수박씨",
  "item.minecraft.beef": "익히지 않은 소고기",
  "item.minecraft.cooked_beef": "스테이크",
  "item.minecraft.chicken": "익히지 않은 닭고기",
  "item.minecraft.cooked_chicken": "익힌 닭고기",
  "item.minecraft.rotten_flesh": "썩은 살점",
  "item.minecraft.ender_pearl": "엔더 진주",
  "item.minecraft.blaze_rod": "블레이즈 막대기",
  "item.minecraft.ghast_tear": "가스트 눈물",
  "item.minecraft.gold_nugget": "금 조각",
  "item.minecraft.nether_wart": "네더 사마귀",
  "item.minecraft.potion": "제작 불가능 물약□효과 없음",
  "item.minecraft.glass_bottle": "유리병",
  "item.minecraft.spider_eye": "거미 눈",
  "item.minecraft.fermented_spider_eye": "발효된 거미 눈",
  "item.minecraft.blaze_powder": "블레이즈 가루",
  "item.minecraft.magma_cream": "마그마 크림",
  "block.minecraft.brewing_stand": "양조기",
  "block.minecraft.cauldron": "가마솥",
  "item.minecraft.ender_eye": "엔더의 눈",
  "item.minecraft.glistering_melon_slice": "반짝이는 수박 조각",
  "item.minecraft.bat_spawn_egg": "박쥐 생성 알",
  "item.minecraft.bee_spawn_egg": "꿀벌 생성 알",
  "item.minecraft.blaze_spawn_egg": "블레이즈 생성 알",
  "item.minecraft.cat_spawn_egg": "고양이 생성 알",
  "item.minecraft.cave_spider_spawn_egg": "동굴 거미 생성 알",
  "item.minecraft.chicken_spawn_egg": "닭 생성 알",
  "item.minecraft.cod_spawn_egg": "대구 생성 알",
  "item.minecraft.cow_spawn_egg": "소 생성 알",
  "item.minecraft.creeper_spawn_egg": "크리퍼 생성 알",
  "item.minecraft.dolphin_spawn_egg": "돌고래 생성 알",
  "item.minecraft.donkey_spawn_egg": "당나귀 생성 알",
  "item.minecraft.drowned_spawn_egg": "드라운드 생성 알",
  "item.minecraft.elder_guardian_spawn_egg": "엘더 가디언 생성 알",
  "item.minecraft.enderman_spawn_egg": "엔더맨 생성 알",
  "item.minecraft.endermite_spawn_egg": "엔더마이트 생성 알",
  "item.minecraft.evoker_spawn_egg": "소환사 생성 알",
  "item.minecraft.fox_spawn_egg": "여우 생성 알",
  "item.minecraft.ghast_spawn_egg": "가스트 생성 알",
  "item.minecraft.guardian_spawn_egg": "가디언 생성 알",
  "item.minecraft.hoglin_spawn_egg": "호글린 생성 알",
  "item.minecraft.horse_spawn_egg": "말 생성 알",
  "item.minecraft.husk_spawn_egg": "허스크 생성 알",
  "item.minecraft.llama_spawn_egg": "라마 생성 알",
  "item.minecraft.magma_cube_spawn_egg": "마그마 큐브 생성 알",
  "item.minecraft.mooshroom_spawn_egg": "무시룸 생성 알",
  "item.minecraft.mule_spawn_egg": "노새 생성 알",
  "item.minecraft.ocelot_spawn_egg": "오실롯 생성 알",
  "item.minecraft.panda_spawn_egg": "판다 생성 알",
  "item.minecraft.parrot_spawn_egg": "앵무새 생성 알",
  "item.minecraft.phantom_spawn_egg": "팬텀 생성 알",
  "item.minecraft.pig_spawn_egg": "돼지 생성 알",
  "item.minecraft.piglin_spawn_egg": "피글린 생성 알",
  "item.minecraft.pillager_spawn_egg": "약탈자 생성 알",
  "item.minecraft.polar_bear_spawn_egg": "북극곰 생성 알",
  "item.minecraft.pufferfish_spawn_egg": "복어 생성 알",
  "item.minecraft.rabbit_spawn_egg": "토끼 생성 알",
  "item.minecraft.ravager_spawn_egg": "파괴수 생성 알",
  "item.minecraft.salmon_spawn_egg": "연어 생성 알",
  "item.minecraft.sheep_spawn_egg": "양 생성 알",
  "item.minecraft.shulker_spawn_egg": "셜커 생성 알",
  "item.minecraft.silverfish_spawn_egg": "좀벌레 생성 알",
  "item.minecraft.skeleton_spawn_egg": "스켈레톤 생성 알",
  "item.minecraft.skeleton_horse_spawn_egg": "스켈레톤 말 생성 알",
  "item.minecraft.slime_spawn_egg": "슬라임 생성 알",
  "item.minecraft.spider_spawn_egg": "거미 생성 알",
  "item.minecraft.squid_spawn_egg": "오징어 생성 알",
  "item.minecraft.stray_spawn_egg": "스트레이 생성 알",
  "item.minecraft.strider_spawn_egg": "스트라이더 생성 알",
  "item.minecraft.trader_llama_spawn_egg": "상인 라마 생성 알",
  "item.minecraft.tropical_fish_spawn_egg": "열대어 생성 알",
  "item.minecraft.turtle_spawn_egg": "거북 생성 알",
  "item.minecraft.vex_spawn_egg": "벡스 생성 알",
  "item.minecraft.villager_spawn_egg": "주민 생성 알",
  "item.minecraft.vindicator_spawn_egg": "변명자 생성 알",
  "item.minecraft.wandering_trader_spawn_egg": "떠돌이 상인 생성 알",
  "item.minecraft.witch_spawn_egg": "마녀 생성 알",
  "item.minecraft.wither_skeleton_spawn_egg": "위더 스켈레톤 생성 알",
  "item.minecraft.wolf_spawn_egg": "늑대 생성 알",
  "item.minecraft.zoglin_spawn_egg": "조글린 생성 알",
  "item.minecraft.zombie_spawn_egg": "좀비 생성 알",
  "item.minecraft.zombie_horse_spawn_egg": "좀비 말 생성 알",
  "item.minecraft.zombie_villager_spawn_egg": "좀비 주민 생성 알",
  "item.minecraft.zombified_piglin_spawn_egg": "좀비화 피글린 생성 알",
  "item.minecraft.experience_bottle": "경험치 병",
  "item.minecraft.fire_charge": "화염구",
  "item.minecraft.writable_book": "책과 깃펜",
  "item.minecraft.written_book": "글이 쓰인 책",
  "item.minecraft.emerald": "에메랄드",
  "item.minecraft.item_frame": "아이템 액자",
  "block.minecraft.flower_pot": "화분",
  "item.minecraft.carrot": "당근",
  "item.minecraft.potato": "감자",
  "item.minecraft.baked_potato": "구운 감자",
  "item.minecraft.poisonous_potato": "독이 있는 감자",
  "item.minecraft.map": "빈 지도",
  "item.minecraft.golden_carrot": "황금 당근",
  "block.minecraft.skeleton_skull": "스켈레톤 해골",
  "block.minecraft.wither_skeleton_skull": "위더 스켈레톤 해골",
  "block.minecraft.player_head": "플레이어 머리",
  "block.minecraft.zombie_head": "좀비 머리",
  "block.minecraft.creeper_head": "크리퍼 머리",
  "block.minecraft.dragon_head": "드래곤 머리",
  "item.minecraft.carrot_on_a_stick": "당근 낚싯대",
  "item.minecraft.warped_fungus_on_a_stick": "뒤틀린 균 낚싯대",
  "item.minecraft.nether_star": "네더의 별",
  "item.minecraft.pumpkin_pie": "호박 파이",
  "item.minecraft.firework_rocket": "폭죽 로켓",
  "item.minecraft.firework_star": "폭죽 탄약",
  "item.minecraft.enchanted_book": "마법이 부여된 책",
  "item.minecraft.nether_brick": "네더 벽돌",
  "item.minecraft.quartz": "네더 석영",
  "item.minecraft.tnt_minecart": "tnt가 실린 광산 수레",
  "item.minecraft.hopper_minecart": "호퍼가 실린 광산 수레",
  "item.minecraft.prismarine_shard": "프리즈머린 조각",
  "item.minecraft.prismarine_crystals": "프리즈머린 수정",
  "item.minecraft.rabbit": "익히지 않은 토끼고기",
  "item.minecraft.cooked_rabbit": "익힌 토끼고기",
  "item.minecraft.rabbit_stew": "토끼 스튜",
  "item.minecraft.rabbit_foot": "토끼발",
  "item.minecraft.rabbit_hide": "토끼 가죽",
  "item.minecraft.armor_stand": "갑옷 거치대",
  "item.minecraft.iron_horse_armor": "철 말 갑옷",
  "item.minecraft.golden_horse_armor": "금 말 갑옷",
  "item.minecraft.diamond_horse_armor": "다이아몬드 말 갑옷",
  "item.minecraft.leather_horse_armor": "가죽 말 갑옷",
  "item.minecraft.lead": "끈",
  "item.minecraft.name_tag": "이름표",
  "item.minecraft.command_block_minecart": "명령 블록이 실린 광산 수레",
  "item.minecraft.mutton": "익히지 않은 양고기",
  "item.minecraft.cooked_mutton": "익힌 양고기",
  "block.minecraft.white_banner": "하얀색 현수막",
  "block.minecraft.orange_banner": "주황색 현수막",
  "block.minecraft.magenta_banner": "자홍색 현수막",
  "block.minecraft.light_blue_banner": "하늘색 현수막",
  "block.minecraft.yellow_banner": "노란색 현수막",
  "block.minecraft.lime_banner": "연두색 현수막",
  "block.minecraft.pink_banner": "분홍색 현수막",
  "block.minecraft.gray_banner": "회색 현수막",
  "block.minecraft.light_gray_banner": "회백색 현수막",
  "block.minecraft.cyan_banner": "청록색 현수막",
  "block.minecraft.purple_banner": "보라색 현수막",
  "block.minecraft.blue_banner": "파란색 현수막",
  "block.minecraft.brown_banner": "갈색 현수막",
  "block.minecraft.green_banner": "초록색 현수막",
  "block.minecraft.red_banner": "빨간색 현수막",
  "block.minecraft.black_banner": "검은색 현수막",
  "item.minecraft.end_crystal": "엔드 수정",
  "item.minecraft.chorus_fruit": "후렴과",
  "item.minecraft.popped_chorus_fruit": "튀긴 후렴과",
  "item.minecraft.beetroot": "비트",
  "item.minecraft.beetroot_seeds": "비트 씨앗",
  "item.minecraft.beetroot_soup": "비트 수프",
  "item.minecraft.dragon_breath": "드래곤의 숨결",
  "item.minecraft.splash_potion": "투척용 제작 불가능 물약□효과 없음",
  "item.minecraft.spectral_arrow": "분광 화살",
  "item.minecraft.tipped_arrow": "물약이 묻은 제작 불가능 화살□효과 없음",
  "item.minecraft.lingering_potion": "잔류형 제작 불가능 물약□효과 없음",
  "item.minecraft.shield": "방패",
  "item.minecraft.elytra": "겉날개",
  "item.minecraft.spruce_boat": "가문비나무 보트",
  "item.minecraft.birch_boat": "자작나무 보트",
  "item.minecraft.jungle_boat": "정글나무 보트",
  "item.minecraft.acacia_boat": "아카시아나무 보트",
  "item.minecraft.dark_oak_boat": "짙은 참나무 보트",
  "item.minecraft.totem_of_undying": "불사의 토템",
  "item.minecraft.shulker_shell": "셜커 껍데기",
  "item.minecraft.iron_nugget": "철 조각",
  "item.minecraft.knowledge_book": "지식의 책",
  "item.minecraft.debug_stick": "디버그 막대기",
  "item.minecraft.music_disc_13": "음반□c418 - 13",
  "item.minecraft.music_disc_cat": "음반□c418 - cat",
  "item.minecraft.music_disc_blocks": "음반□c418 - blocks",
  "item.minecraft.music_disc_chirp": "음반□c418 - chirp",
  "item.minecraft.music_disc_far": "음반□c418 - far",
  "item.minecraft.music_disc_mall": "음반□c418 - mall",
  "item.minecraft.music_disc_mellohi": "음반□c418 - mellohi",
  "item.minecraft.music_disc_stal": "음반□c418 - stal",
  "item.minecraft.music_disc_strad": "음반□c418 - strad",
  "item.minecraft.music_disc_ward": "음반□c418 - ward",
  "item.minecraft.music_disc_11": "음반□c418 - 11",
  "item.minecraft.music_disc_wait": "음반□c418 - wait",
  "item.minecraft.music_disc_pigstep": "음반□lena raine - pigstep",
  "item.minecraft.trident": "삼지창□□주로 사용하는 손에 있을 때:□+8 공격 피해□-2.9 공격 속도",
  "item.minecraft.phantom_membrane": "팬텀 막",
  "item.minecraft.nautilus_shell": "앵무조개 껍데기",
  "item.minecraft.heart_of_the_sea": "바다의 심장",
  "item.minecraft.crossbow": "쇠뇌",
  "item.minecraft.suspicious_stew": "수상한 스튜",
  "block.minecraft.loom": "베틀",
  "item.minecraft.flower_banner_pattern": "현수막 무늬□꽃 모양",
  "item.minecraft.creeper_banner_pattern": "현수막 무늬□크리퍼 모양",
  "item.minecraft.skull_banner_pattern": "현수막 무늬□해골 모양",
  "item.minecraft.mojang_banner_pattern": "현수막 무늬□무언가",
  "item.minecraft.globe_banner_pattern": "현수막 무늬□지구 모양",
  "item.minecraft.piglin_banner_pattern": "현수막 무늬□돼지코",
  "block.minecraft.composter": "퇴비통",
  "block.minecraft.barrel": "통",
  "block.minecraft.smoker": "훈연기",
  "block.minecraft.blast_furnace": "용광로",
  "block.minecraft.cartography_table": "지도 제작대",
  "block.minecraft.fletching_table": "화살 작업대",
  "block.minecraft.grindstone": "숫돌",
  "block.minecraft.lectern": "독서대",
  "block.minecraft.smithing_table": "대장장이 작업대",
  "block.minecraft.stonecutter": "석재 절단기",
  "block.minecraft.bell": "종",
  "block.minecraft.lantern": "랜턴",
  "block.minecraft.soul_lantern": "영혼 랜턴",
  "item.minecraft.sweet_berries": "달콤한 열매",
  "block.minecraft.campfire": "모닥불",
  "block.minecraft.soul_campfire": "영혼 모닥불",
  "block.minecraft.shroomlight": "버섯불",
  "item.minecraft.honeycomb": "벌집 조각",
  "block.minecraft.bee_nest": "벌집",
  "block.minecraft.beehive": "벌통",
  "item.minecraft.honey_bottle": "꿀이 든 병",
  "block.minecraft.honey_block": "꿀 블록",
  "block.minecraft.honeycomb_block": "벌집 조각 블록",
  "block.minecraft.lodestone": "자석석",
  "block.minecraft.netherite_block": "네더라이트 블록",
  "block.minecraft.ancient_debris": "고대 잔해",
  "block.minecraft.target": "과녁",
  "block.minecraft.crying_obsidian": "우는 흑요석",
  "block.minecraft.blackstone": "흑암",
  "block.minecraft.blackstone_slab": "흑암 반 블록",
  "block.minecraft.blackstone_stairs": "흑암 계단",
  "block.minecraft.gilded_blackstone": "황금이 박힌 흑암",
  "block.minecraft.polished_blackstone": "윤나는 흑암",
  "block.minecraft.polished_blackstone_slab": "윤나는 흑암 반 블록",
  "block.minecraft.polished_blackstone_stairs": "윤나는 흑암 계단",
  "block.minecraft.chiseled_polished_blackstone": "조각된 윤나는 흑암",
  "block.minecraft.polished_blackstone_bricks": "윤나는 흑암 벽돌",
  "block.minecraft.polished_blackstone_brick_slab": "윤나는 흑암 벽돌 반 블록",
  "block.minecraft.polished_blackstone_brick_stairs": "윤나는 흑암 벽돌 계단",
  "block.minecraft.cracked_polished_blackstone_bricks": "금 간 윤나는 흑암 벽돌",
  "block.minecraft.respawn_anchor": "리스폰 정박기",
}
export const ko_kr = items; 
